export const shadowVariants = {
  variants: {
    shadow: {
      sm: "oui-shadow-sm",
      base: "oui-shadow",
      md: "oui-shadow-md",
      lg: "oui-shadow-lg",
      xl: "oui-shadow-xl",
      "2xl": "oui-shadow-2xl",
      inner: "oui-shadow-inner",
      none: "oui-shadow-none",
    },
  },
};
